import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppProviders from './providers/AppProviders';
import { useAuth } from './context/AuthContext';
import {
  LoginPage,
  SetPasswordPage,
  ForgotPasswordPage,
  ResetPasswordPage,
} from './modules/auth';
import Layout from './components/Layout/Layout';
import { BridgeListPage } from './modules/bridges';
import { DashboardPage } from './modules/dashboard';
import { SensorDataPage } from './modules/sensor-data';
import { ReportPage } from './modules/reports';
import { CompaniesPage } from './modules/companies';

const ProtectedRoute = ({ children }) => {
  const { token } = useAuth();
  return token ? children : <Navigate to="/login" replace />;
};

const SuperAdminRoute = ({ children }) => {
  const { token, user } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  if (user?.role !== 'super_admin') return <Navigate to="/bridges" replace />;
  return children;
};

const HomeRedirect = () => {
  const { user } = useAuth();
  if (user?.role === 'super_admin') return <Navigate to="/companies" replace />;
  if (user?.role === 'bridge_engineer') return <Navigate to="/bridges" replace />;
  return <Navigate to="/dashboard" replace />;
};

const DashboardRoute = ({ children }) => {
  const { user } = useAuth();
  if (user?.role === 'bridge_engineer') return <Navigate to="/bridges" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<HomeRedirect />} />
        <Route path="bridges" element={<BridgeListPage />} />
        <Route
          path="companies"
          element={
            <SuperAdminRoute>
              <CompaniesPage />
            </SuperAdminRoute>
          }
        />
        <Route path="dashboard" element={<DashboardRoute><DashboardPage /></DashboardRoute>} />
        <Route path="sensor-data" element={<SensorDataPage />} />
        <Route path="report" element={<ReportPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}

export default App;
